<template>
  <v-card width="500" class="mx-auto mt-5">
    <v-card-title>
      <h1 class="display-1">{{ title }}</h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <div v-if="mode !== 'confirmEmail'">
          <v-text-field
            v-if="mode !== 'changePassword'"
            label="email"
            id="email"
            v-model="email"
            @input="
              v => {
                email = v.toLowerCase();
              }
            "
          />
          <div v-if="mode !== 'forgotPassword'">
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :type="showPassword ? 'text' : 'password'"
              :label="
                mode === 'changePassword' ? 'Nueva Contraseña' : 'Contraseña'
              "
              id="Password"
              v-model="password"
            />
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :type="showPassword ? 'text' : 'password'"
              :label="
                mode === 'changePassword'
                  ? 'Confirme Nueva Contraseña'
                  : 'Confirme Contraseña'
              "
              id="confirmedPassword"
              v-model="confirmed_password"
            />
          </div>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions class="d-flex flex-column">
      <v-btn
        color="success"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="confirm"
      >
        {{ buttontext }}
      </v-btn>
      <v-btn
        color="warning"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="cancel"
      >
        Cancelar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "Register",

  components: {
    //
  },

  data: () => ({
    mode: null,
    title: null,
    buttontext: null,
    showPassword: false,
    email: null,
    password: null,
    confirmed_password: null,
    uid: null,
    token: null
  }),

  methods: {
    async confirm() {
      try {
        if (this.mode === "changePassword" && this.$bRoot.auth.loggedIn) {
          await this.$bRoot.axios.post("/user/force_change_password/", {
            new_password1: this.password,
            new_password2: this.confirmed_password
          });
          await this.$confirm("Cambio de contraseña realizado con éxito");
          await this.$bRoot.axios.post("/rest-auth/logout/");
          this.$cookies.remove("csrftoken");
          this.$cookies.remove("sessionid");
          window.location.assign(this.$bRoot.CLI_SERVER);
          return;
        }

        let result = await this.$bRoot.auth.registration(
          this.email,
          this.password,
          this.confirmed_password,
          this.mode,
          this.uid,
          this.token
        );
        if (result) {
          let msg = null;
          switch (this.mode) {
            case "forgotPassword":
              msg =
                "Verifique su casilla de email <b>(incluyendo SPAM)</b> por más instrucciones";
              break;
            case "register":
              msg =
                "Verifique su casilla de email <b>(incluyendo SPAM)</b> para confirmar la registración";
              break;
            case "changePassword":
              msg = "Cambio de contraseña realizado con éxito";
              break;
            case "confirmEmail":
              msg =
                "Felicitaciones!, su cuenta está configurada, utilice sus credenciales para ingresar al sistema.";
              break;
          }
          if (!msg) {
            throw "El proceso finalizó con error. Vuelva a Intentarlo";
          }
          this.$confirm(msg);
          if (this.mode === "confirmEmail" || this.mode === "changePassword") {
            await this.$bRoot.axios.post("/rest-auth/logout/");
            this.$cookies.remove("csrftoken");
            this.$cookies.remove("sessionid");
          }
          this.$router.push({ name: "Login" });
        } else {
          throw "El proceso finalizó con error. Vuelva a Intentarlo";
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    async cancel() {
      if (
        this.mode === "changePassword" &&
        this.$bRoot.auth.loggedIn &&
        this.$bRoot.auth.password_expired
      ) {
        await this.$bRoot.axios.post("/rest-auth/logout/");
        this.$cookies.remove("csrftoken");
        this.$cookies.remove("sessionid");
        window.location.assign(this.$bRoot.CLI_SERVER);
        return;
      } else if (this.mode === "changePassword" && this.$bRoot.auth.loggedIn) {
        this.$router.push({ name: "Home" });
        return;
      } else {
        this.$router.push({ name: "Login" });
      }
    }
  },

  async mounted() {
    this.mode = this.$route.params.mode;

    // Si es cambio por password expirada, NO hacer logout
    if (this.mode === "changePassword" && this.$bRoot.auth.loggedIn) {
      this.title = this.$bRoot.auth.password_expired
        ? "Contraseña Expirada"
        : "Cambiar Contraseña";
      this.buttontext = "Actualizar Contraseña";
      return;
    }

    // Para otros casos, mantener el comportamiento actual
    this.$bRoot.axios.post("/user/logout/");

    if (this.mode === "forgotPassword") {
      this.title = "Restablecer Contraseña";
      this.buttontext = "Restablecer";
    } else if (this.mode === "register") {
      this.title = "Registro de usuario";
      this.buttontext = "Registrarse";
    } else if (this.mode === "changePassword") {
      this.title = "Nueva Contraseña";
      this.buttontext = "Cambiar";
      this.uid = this.$route.params.uid;
      this.token = this.$route.params.token;
    } else if (this.mode === "confirmEmail") {
      this.title = "Confirmación de Registración";
      this.buttontext = "Confirmar";
      this.token = this.$route.params.token;
      await this.confirm();
    } else {
      this.$bRoot.setError("No se informó Acción");
      this.$router.push({ name: "Login" });
    }
    return;
  }
};
</script>
